import { useState, useEffect } from "react"
import { useQuery } from "@tanstack/react-query"
import { fetchStatementYears } from "../queries"
import { Heading } from "@planningcenter/doxy-web"
import { AlertMessage, Loading, Icon } from "source/shared/components"
import { StatementYearFilter } from "./components/StatementYearFilter"
import StatementsList from "./components/StatementsList"
import { Suspense } from "react"
import { css } from "@emotion/react"
import { NotifyNativeLoaded } from "source/shared/hooks/useNotifyNativeLoaded"
import NativeHeader from "source/shared/NativeHeader"

export default function Statements() {
  const [activeYear, setActiveYear] = useState<number | null>(null)

  const {
    data: statementYears = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["StatementYears"],
    queryFn: fetchStatementYears,
  })

  useEffect(() => {
    if (statementYears.length > 0 && activeYear === null) {
      setActiveYear(statementYears[0])
    }
  }, [statementYears, activeYear])

  const handleYearChange = (year: number) => {
    setActiveYear(year)
  }

  return (
    <>
      <NativeHeader title="Statements" />
      <section>
        <div className="mb-2 d-n d-f@md">
          <Heading level={1} size={2} text="Statements" />
        </div>
        {isError ? (
          <>
            <NotifyNativeLoaded />
            <AlertMessage type="error" icon="general#exclamation-triangle">
              Something went wrong. Please try again.
            </AlertMessage>
          </>
        ) : isLoading ? (
          <Loading message="Loading" />
        ) : (
          <div className="d-f fd-c g-2">
            {statementYears?.length > 0 && activeYear ? (
              <>
                <StatementYearFilter
                  statementYears={statementYears}
                  activeStatementYear={activeYear}
                  onChange={handleYearChange}
                />
                <Suspense fallback={<Loading />}>
                  <NotifyNativeLoaded />
                  <StatementsList activeYear={activeYear} />
                </Suspense>
              </>
            ) : (
              <>
                <NotifyNativeLoaded />
                <div className="ta-c c-tint3 p-4">
                  <Icon
                    symbol="general#thick-to-bottom-arrow"
                    css={css`
                      width: 34px;
                      height: 34px;
                    `}
                    className="mb-1"
                    title="arrow pointing down"
                  />
                  <p>No statements available to download</p>
                </div>
              </>
            )}
          </div>
        )}
      </section>
    </>
  )
}
